import { render, staticRenderFns } from "./FloatingButtonComponent.vue?vue&type=template&id=0f1f4885"
import script from "./FloatingButtonComponent.vue?vue&type=script&lang=js"
export * from "./FloatingButtonComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1f4885')) {
      api.createRecord('0f1f4885', component.options)
    } else {
      api.reload('0f1f4885', component.options)
    }
    module.hot.accept("./FloatingButtonComponent.vue?vue&type=template&id=0f1f4885", function () {
      api.rerender('0f1f4885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FloatingButtonComponent.vue"
export default component.exports